import React, { useState, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import {
  Collapsible,
  Checkbox,
  Badge,
  Button,
  Spinner,
  ButtonGroup,
  ExceptionList,
  Popover,
  ActionList,
  Banner,
  Modal,
  Icon,
  Toast,
  Tooltip,
  InlineStack,
  Box,
  Text,
} from "@shopify/polaris";
import {
  // PlusMinor,
  DeleteMajor,
  EditMinor,
  BuyButtonMajor,
  DragDropMajor,
  WholesaleMajor,
  ColorNoneMinor,
  // MobileCancelMajor,
  AlertMinor,
  // TemplateMajor,
  // QuestionMarkMinor,
} from "@shopify/polaris-icons";
import intl from "../../../../../i18n/intl";
// * 页面组件
import PlaceholderImage from "../../../../../components/PlaceholderImage";
import ProductInfo from "../ProductInfo";
import WholesaleModal from "../Wholesale";
import utils from "../../../../../utils/utils";
// * css
import "../../index.css";
import { useGetState } from "ahooks";
import { store } from "../../../../../store";
import { useSelector} from "react-redux";
/**
 * 商品列表数据
 * @param {Object} data 商品详情
 * @param {Array} currTab 当前选中tabs
 * @param {Function} onChange 修改商品详情
 * @param {Function} callback 用于吊起弹窗的回调 3个参数 type是弹窗类型 isBulk是否是批量操作 isBulkEdit是否批量编辑
 * @returns
 */
const TableSelect = ({
  data,
  recordKey,
  currTab,
  onChange,
  callback,
  deleteImportProduct,
  setList,
  list,
  callBackFun,
  currentSelected,
  setChatData,
  chatData,
  // handlePageFly,
  callResetPage
}) => {
  const history = useHistory();
  const [popoverActive, setPopoverActive] = useState(false); // 是否打开More action
  const [contentData, setContentData, getContentData] = useGetState({
    sourcingLimitModalShow: false,
    sourcingDay: data?.sourcing_day,
  });
  const [WholesaleModalData, setWholesaleModalData] = useGetState("");
  const [seoModalData, setSeoModalData] = useGetState("");
  // 切换More action状态
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );

  // 勾选
  const handleChange = (item) => {
    item.checked = item.checked === 0 ? 1 : 0;
    onChange(item);
    // eslint-disable-next-line
  };

  // 展开/收缩
  const handleToggle = (id) => {
    const lists = list.map((item) => {
      if (item.id === id) {
        return { ...item, collapsibleShow: item.collapsibleShow === 0 ? 1 : 0 };
      } else {
        return item;
      }
    });
    setList(lists);
  };

  const handleBuy = (id) => {
    togglePopoverActive();
    utils.routeListen("/admin/find_products/product-info?filter=" + id);
    utils.routeJump1(history, "/admin/find_products/product-info?filter=" + id);
  };

  const handleDelete = () => {
    callback("delete", [data?.id], false, false, recordKey);
    togglePopoverActive();
  };
  // SEO集成
  const handleSeoAudit = async () => {
    let person = store.getState().languageReducer.subScriptData;
    let params = {
      website: person.domain,
      data_id: data.ProductId,
      action: "product",
    };
    try {
      await fetch(
        `https://api-admin.seoant.com/open-api/v1/coop-seo/jumpOnPage`,
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(params),
        }
      )
        .then((response) => response.json())
        .then((res) => {
          if (res.code === 200) {
            if (res.data.status === 1) {
              window.open(res.data.jump_url, "_blank");
            } else {
              let seoModal = (
                <Modal
                  // large
                  open={true}
                  onClose={() => setSeoModalData("")}
                >
                  <div className="seo_ant_modal">
                    <div className="seo_ant_modal_title">
                      {intl.get(
                        "SEO audit needs SEOAnt installation, deeply integrated with Dropshipman."
                      )}{" "}
                      <span></span>
                    </div>
                    <div className="seo_ant_modal_banner">
                      <img
                        height={240}
                        src="/seoExperts/seo_modal_banner.png"
                        alt="dropshipman"
                      />
                    </div>
                    <div className="seo_ant_modal_button">
                      <Button onClick={() => setSeoModalData("")}>
                        {intl.get("Cancel")}
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => {
                          window.open(
                            res.data.jump_url
                              ? res.data.jump_url
                              : "https://share.channelwill.com/app/116548bae341884wGT",
                            "_blank"
                          );
                        }}
                      >
                        {intl.get("Try It For Free Now")}
                      </Button>
                    </div>
                  </div>
                </Modal>
              );
              setSeoModalData(seoModal);
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (err) {
      console.warn("Error:", err);
    }
  };
  const handlePageDesign = ()=>{
    window.open("https://pagef.ly/1uckx9", "_blank");
  }
  // More actions 按钮
  const activator = (
    <Button onClick={togglePopoverActive} disclosure>
      {intl.get("More actions")}
    </Button>
  );

  // 封装相同部分
  const encapsulationExceptionList = (icon, description) => {
    return (
      <ExceptionList
        items={[
          {
            icon,
            description,
          },
        ]}
      />
    );
  };
  const language = useSelector(state => state.languageReducer.language);
  const userData = useSelector(state => state.languageReducer.subScriptData);

  // More actions 浮层列表
  const moreActionList = useMemo(() => {
    if (
      currTab?.[0] === "Imported" &&
      (data?.product_source_from === 2 || data?.product_source_from === 4 || data?.product_source_from === 5) &&
      data?.productStatus === 1
    ) {
      if (data?.product_source_from === 5 && (data?.originalId !== 0 && data?.originalId !== '')) {
        return [
          {
            content: encapsulationExceptionList(
              BuyButtonMajor,
              intl.get("Buy")
            ),
            onAction: () => handleBuy(data?.originalId),
          },
          userData.domain === '4cd062.myshopify.com' && {
            content: encapsulationExceptionList(
              WholesaleMajor,
              intl.get("Wholesale")
            ),
            onAction: () => handleWholesaleModal(data?.id, data?.CountryCode),
          },
          {
            content: encapsulationExceptionList(
              DeleteMajor,
              intl.get("Remove")
            ),
            onAction: handleDelete,
          },
          {
            content: encapsulationExceptionList(
              DragDropMajor,
              intl.get("Seo Audit")
            ),
            onAction: handleSeoAudit,
          },
          {
            content: encapsulationExceptionList(
              ColorNoneMinor,
              intl.get("Page Design")
            ),
            onAction: handlePageDesign,
          },
          
        ];
      } else {
        return [
          {
            content: encapsulationExceptionList(
              DeleteMajor,
              intl.get("Remove")
            ),
            onAction: handleDelete,
          },
          {
            content: encapsulationExceptionList(
              DragDropMajor,
              intl.get("Seo Audit")
            ),
            onAction: handleSeoAudit,
          },
          {
            content: encapsulationExceptionList(
              ColorNoneMinor,
              intl.get("Page Design")
            ),
            onAction: handlePageDesign,
          },
        ];
      }
    } else {
      return [
        {
          content: encapsulationExceptionList(DeleteMajor, intl.get("Remove")),
          onAction: handleDelete,
        },
      ];
    }
    // eslint-disable-next-line
  }, [currTab, data,language]);
  // const optionDataDisabled = ()=>{
  //   let text = false;
  //   list.forEach(it=>{
  //     if ((it.variants_count >0 && it.id === data.id &&  data.options[0] === '') ||  (it.id === data.id && data.options[0] === '' )) {
  //       text = true;
  //     }
  //     if (it.variants_count >0 && it.id === data.id && it?.productStatus === 5) {
  //       text = true;
  //     }
  //   })

  //   return text;
  // }
  // 不同tabs展示不同操作按钮
  const showButton = useMemo(() => {
    const isDisabled =
      data?.productStatus === 2 ||
      data?.productStatus === 3 ||
      data?.productStatus === 5 ||
      data?.productStatus === 6 ||
      data?.productStatus === 7;
    return currTab?.[0] !== "Imported" && currTab?.[0] !== "Deleted" ? (
      <Button
        variant="primary"
        disabled={isDisabled}
        onClick={
          isDisabled
            ? () => {}
            : () => callback("import", [data?.id], false, false, recordKey)
        }
      >
        {intl.get("List product")}
      </Button>
    ) : currTab?.[0] === "Imported" ? (
      <Button variant="plain" url={data?.EditOnShopify} external>
        {encapsulationExceptionList(EditMinor, intl.get("Edit on Shopify"))}
      </Button>
    ) : null;
    // eslint-disable-next-line
  }, [currTab, data,language]);

  const [showToast, setShowToast] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
  //提示弹窗
  const toggleToast = (showToastText, showToastIserror = false) => {
    setShowToast(!showToast);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };

  const toastMarkup = showToast ? (
    <Toast
      content={showToastText}
      onDismiss={() => toggleToast("")}
      error={showToastIserror}
    />
  ) : null;

  // sourcing请求弹窗控制开关
  const handleSourcingLimitModal = () => {
    setContentData((prevValue) => ({
      ...prevValue,
      sourcingLimitModalShow: !getContentData().sourcingLimitModalShow,
    }));
  };
  // 激活聊天弹窗
  const handleActiveMessageBox = (message = "") => {
    if (message === "") {
      message =
        "Hello, I would like to get more sourcing times. Can you help me?";
    }
    try {
      // 填充信息并激活对话弹窗
      // window.Intercom('showNewMessage', message);
      window.Willdesk.show();
      window.Willdesk.chat(message);
    } catch (error) {
      // toggleToast(
      //   "Intercom is not loaded. Please check your network and refresh the page.",
      //   true
      // );
      console.info(error);
    }

    if (
      message ===
      "Hello, I would like to get more sourcing times. Can you help me?"
    ) {
      handleSourcingLimitModal();
    }
  };
  // 店铺版本为trial用户(201)的限制提示 或 非trail用户（202）
  const sourcingLimitTips = (
    <Modal
      open={contentData.sourcingLimitModalShow}
      onClose={handleSourcingLimitModal}
      title={
        <div className="modalHasIcon">
          <Icon source={AlertMinor} color="critical" />
          <span>{intl.get("Reach the sourcing limit")}</span>
        </div>
      }
      primaryAction={{
        content: intl.get("ok"),
        onAction: handleSourcingLimitModal,
      }}
    >
      <Modal.Section>
        <p style={{ fontSize: 15 }}>
          {intl.get(
            "Sorry, you have reached the daily sourcing limit of {{count}} times.",
            contentData.sourcingDay
          )}
        </p>
      </Modal.Section>
    </Modal>
  );

  let rowHtml = "";
  let badge = "";
  const statusData = (type) => {
    let text = "For Sale";
    // let tool = ''
    switch (type) {
      case 1:
        text = "For Sale";
        break;
      case 2:
        text = "Offline";
        break;
      case 3:
        text = "Offline";
        break;
      case 4:
        text = "Offline";
        break;
      case 5:
        text = "Abnormal";
        // tool = 'The imported product variants exceed the 100-variant limit. Please reduce variants and try importing again.'
        break;
      case 6:
        text = "Overload";
        // tool = 'Imported product variant or option attributes have empty values. Please fill them and try importing again.'
        break;
      case 7:
        text = "Abnormal";
        break;
      default:
        break;
    }
    // list.forEach(it=>{
    //     if (it.id === data.id && it.options[0] === '' && it.options[1] === '' && it.options[2] === '') {
    //       text = 'Abnormal'
    //     }
    //   })
    return text;
  };
  if (data?.status !== "") {
    switch (data?.status) {
      case 0:
        badge = <Badge tone={"info"}>{intl.get("Not Listed")}</Badge>;
        break;
      case 1:
        badge = <Badge>{intl.get("Listed")}</Badge>;
        break;
      case 2:
        badge = <Badge tone={"info"}>{intl.get("Not Listed")}</Badge>;
        break;
      case 3:
        badge = (
          <div className="Product_Status_Badge attention">
            <Badge>{intl.get("Deleted")}</Badge>
          </div>
        );
        break;
      default:
        break;
    }
  }
  if (data?.productStatus === 0) {
    rowHtml = (
      <div className="grid gap-6 grid-cols-12 sm-grid-cols-18 xxl-grid-cols-24 items-center">
        <div className="col-span-3 xs-col-span-2 lg-col-span-1">
          <div>
            <Checkbox
              label=""
              labelHidden
              checked={false}
              onChange={() => {}}
              disabled={true}
            />
          </div>
        </div>
        <div className="col-span-9 xs-col-span-3 lg-col-span-2">
          <PlaceholderImage
            src={data?.ImageUrl}
            size={58}
            alt="product image"
          />
        </div>
        <div className="col-span-12 lg-col-span-11 xl-col-span-7">
          <div style={{ fontWeight: "500" }}>
            {intl.get("Syncing product") + ":  " + data.Title}
          </div>
        </div>
        <div className="col-span-12 xs-col-span-4 sm-col-span-5 md-col-span-9  lg-col-span-4  xl-col-span-3  xxl-col-span-4 xxxl-col-span-3">
          <div className="flex flex-col text-start md-text-start lg-text-end xl-text-start"></div>
        </div>
        <div className="col-span-12 xs-col-span-4 md-col-span-5 lg-col-span-3"></div>
        <div className="col-span-12 xs-col-span-4 lg-col-span-7 xl-col-span-2"></div>
        <div className="col-span-12 lg-col-span-8 xl-col-span-7 xxxl-col-span-6">
          <ButtonGroup>
            <div
              className="Product_Action"
              style={{ padding: "16px 12px 25px 25px" }}
            >
              <Spinner
                accessibilityLabel="Searching Product"
                color="teal"
                size="small"
              />
            </div>
          </ButtonGroup>
        </div>
      </div>
    );
  } else if (data?.productStatus === 4) {
    rowHtml = (
      <div className="grid">
        <section>
          <Box
          // title={data.Title}
          // actions={[
          //   {
          //     content: (
          //       <ExceptionList
          //         items={[
          //           {
          //             icon: MobileCancelMajor,
          //             description: " ",
          //           },
          //         ]}
          //       />
          //     ),
          //     onAction: () => deleteImportProduct(recordKey, data.id),
          //   },
          // ]}
          >
            <InlineStack align="space-between">
              <Text variant="headingMd" as="h6">
                {data.Title}
              </Text>
              {/* <ExceptionList
                  items={[
                    {
                      icon: MobileCancelMajor,
                      description: " ",
                    },
                  ]}
                /> */}
              {/* <Button variant="plain" onClick={() => deleteImportProduct(recordKey, data.id)} ><Icon
              source={MobileCancelMajor}
              tone="base"
            /></Button> */}
            </InlineStack>
            <div className="Product__Status_Pushed__Warning Intercom_Information_fill">
              <Banner
                title={intl.get("Product no longer available")}
                tone="critical"
                action={{
                  content: "Remove",
                  onAction: () => deleteImportProduct(recordKey, data.id),
                }}
              >
                <p
                  onClick={() =>
                    handleActiveMessageBox(
                      "aliExpress product id: " +
                        data.ali_product_id +
                        ", get error: " +
                        data.warningMessage
                    )
                  }
                >
                  {data.warningMessage}
                </p>
              </Banner>
            </div>
          </Box>
        </section>
      </div>
    );
  } else {
    rowHtml = (
      <div>
        {(data?.productStatus === 5 ||
          data?.productStatus === 6 ||
          data?.productStatus === 7) && (
          <div
            style={{ marginBottom: "16px" }}
            className="Product__Status_Pushed__Warning Intercom_Information_fill"
          >
            <Banner
              title={intl.get("Anomaly detected")}
              action={{
                content: intl.get("Contact us"),
                onAction: () => {
                  window.Willdesk.show();
                  window.Willdesk.chat("");
                },
              }}
              tone="critical"
            >
              <p>
                {data?.productStatus === 5 &&
                  intl.get(
                    "The product variants exceed the 100-variant limit. Please reduce variants and try listing again Or you can contact us for help."
                  )}
                {data?.productStatus === 6 &&
                  intl.get(
                    "Empty product variant attributes. Please fill and retry after refreshing Or you can contact us for help."
                  )}
                {data?.productStatus === 7 &&
                  intl.get(
                    "Duplicate product variants found. Please edit and retry after refreshing Or you can contact us for help."
                  )}
              </p>
            </Banner>
          </div>
        )}
        <div className="grid gap-6 grid-cols-12 sm-grid-cols-18 xxl-grid-cols-24 items-center">
          <div className="col-span-3 xs-col-span-2 lg-col-span-1">
            <div>
              {currTab?.[0] === "Not imported" ||
              currTab?.[0] === "Recommend" ? (
                <Checkbox
                  checked={data?.checked === 1}
                  // disabled={data?.productStatus !== 1}
                  disabled={
                    (data?.productStatus !== 1 && data?.status === 0) ||
                    data.status === 2
                  }
                  onChange={() => handleChange(data)}
                />
              ) : (
                <Checkbox
                  checked={data?.checked === 1}
                  // disabled={data?.productStatus !== 1}
                  disabled={data?.status === 2}
                  onChange={() => handleChange(data)}
                />
              )}
            </div>
          </div>
          <div className="col-span-9 xs-col-span-3 lg-col-span-2">
            <PlaceholderImage
              src={data?.ImageUrl}
              size={58}
              alt="product image"
            />
          </div>
          <div className="col-span-12 lg-col-span-11 xl-col-span-7 cursor-pointer">
            <div
              className="tab-select__title"
              onClick={() =>
                (data?.status === 0 || data?.status === 1) &&
                (data?.productStatus === 1 ||
                  data?.productStatus === 2 ||
                  data?.productStatus === 5 ||
                  data?.productStatus === 6 ||
                  data?.productStatus === 7)
                  ? handleToggle(data.id)
                  : ""
              }
            >
              {data?.Title}
            </div>
          </div>
          <div className="col-span-12 xs-col-span-4 sm-col-span-5 md-col-span-9  lg-col-span-4  xl-col-span-3  xxl-col-span-4 xxxl-col-span-3">
            <div className="flex flex-col text-start md-text-start lg-text-end xl-text-start">
              <span>
                {intl.get("Cost")}: {data?.costRange}
              </span>
              <span
                className="text-grey-400"
                style={{ color: "rgb(162, 160, 160)" }}
              >
                {intl.get("Price")}: {data?.priceRange}
              </span>
            </div>
          </div>
          <div className="col-span-12 xs-col-span-4 md-col-span-5 lg-col-span-3">
            {badge}
          </div>
          <div className="col-span-12 xs-col-span-4 lg-col-span-7 xl-col-span-2">
            {data?.productStatus === 5 ||
            data?.productStatus === 6 ||
            data?.productStatus === 7 ? (
              <Tooltip
                content={
                  data?.productStatus === 5
                    ? intl.get(
                        "The product variants exceed the 100-variant limit. Please reduce variants and try listing again Or you can contact us for help."
                      )
                    : data?.productStatus === 6
                    ? intl.get(
                        "Empty product variant attributes. Please fill and retry after refreshing Or you can contact us for help."
                      )
                    : data?.productStatus === 7
                    ? intl.get(
                        "Duplicate product variants found. Please edit and retry after refreshing Or you can contact us for help."
                      )
                    : ""
                }
              >
                <Badge
                  tone={
                    statusData(data?.productStatus) === "For Sale" &&
                    data?.productStatus === 1
                      ? ""
                      : "critical"
                  }
                >
                  {statusData(data?.productStatus)}
                </Badge>
              </Tooltip>
            ) : (
              <Badge
                tone={
                  statusData(data?.productStatus) === "For Sale" &&
                  data?.productStatus === 1
                    ? ""
                    : "critical"
                }
              >
                {statusData(data?.productStatus)}
              </Badge>
            )}
          </div>
          <div className="col-span-12 lg-col-span-8 xl-col-span-7 xxxl-col-span-6">
            {data?.status === 2 ? (
              <div className="flex uploading">
                <Spinner
                  accessibilityLabel="Uploading Product"
                  color="teal"
                  size="small"
                />
                <div style={{ paddingLeft: "10px", fontSize: "14px" }}>
                  {intl.get("uploading...")}
                </div>
              </div>
            ) : (
              <ButtonGroup>
                {showButton}
                <Popover
                  active={popoverActive}
                  activator={activator}
                  onClose={togglePopoverActive}
                >
                  <ActionList actionRole="menuitem" items={moreActionList} />
                </Popover>
                {/* <div
                  className="pagefly_button"
                  onClick={() => {
                    handlePageFly(true);
                  }}
                >
                  <Tooltip content="Product template">
                    <Icon source={TemplateMajor} tone="base" />
                  </Tooltip>
                </div> */}
              </ButtonGroup>
            )}
          </div>
        </div>
      </div>
    );
  }
  // 批发产品弹窗
  const handleWholesaleModal = (
    dropshipmanUserProductTableId,
    shopifyCountryCode = "US"
  ) => {
    if (dropshipmanUserProductTableId === 0) {
      return false;
    }

    let content = (
      <WholesaleModal
        show={true}
        id={dropshipmanUserProductTableId}
        shopifyCountryCode={shopifyCountryCode}
        callBackFun={callBackFun}
      />
    );
    setWholesaleModalData(content);
  };

  return (
    <Box
      className={`content_item tab-select ${
        data?.checked === 1 ? "is-checked" : ""
      }`}
    >
      <div>
        {rowHtml}
        {/* 产品详情 */}
        <Collapsible
          open={
            // data?.status !== 3 &&
            (data?.status === 0 || data?.status === 1) &&
            (data?.productStatus === 1 ||
              data?.productStatus === 2 ||
              data?.productStatus === 5 ||
              data?.productStatus === 6 ||
              data?.productStatus === 7) &&
            data?.collapsibleShow === 1
          }
          id={"basic-collapsible"}
          transition={{ duration: "150ms", timingFunction: "ease-in-out" }}
          expandOnPrint
        >
          <ProductInfo
            setChatData={setChatData}
            callResetPage={callResetPage}
            chatData={chatData}
            recordKey={recordKey}
            productInfo={list[recordKey]}
            productInfoData={list}
            onChange={onChange}
            productInfoSet={setList}
            currentSelected={currentSelected}
          />
        </Collapsible>

        {/* 批发弹窗 */}
        {WholesaleModalData}
        {seoModalData}
        {/* sourcing 限制提示 */}
        {sourcingLimitTips}
        {/* 常规提示 */}
        {toastMarkup}
      </div>
    </Box>
  );
};

export default TableSelect;
